import { useMemo } from 'react';
import { groupMemberNoDeposits } from '@/helpers/user';
import { useGetCommonStore } from '@/store';

export const useIsNoDepositUser = () => {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();

  const isNoDepositUser = useMemo(() => groupMemberNoDeposits(user), [user]);

  return { isNoDepositUser };
};
